import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';
import { CustomerRecipe } from '../../../models/CustomerRecipe';

export class GetCustomerRecipeHistoricByShopifyCustomerIdService extends HttpServiceBase {

    handle = (input: GetCustomerRecipeHistoricByShopifyCustomerIdServiceInput): Promise<Result<GetCustomerRecipeHistoricByShopifyCustomerIdServiceOutput>|null> => {
        const promise = this.http.get<Result<GetCustomerRecipeHistoricByShopifyCustomerIdServiceOutput>>(
          `${this.baseUrlSislogApi}/point-of-sale/customer-recipe-historic/${input.shopifyCustomerId}?apiKey=${this.getSislogApiKey()}`);
        return promise;
    }
}

export class GetCustomerRecipeHistoricByShopifyCustomerIdServiceInput {
  shopifyCustomerId: string;
}

export class GetCustomerRecipeHistoricByShopifyCustomerIdServiceOutput {
  recipes?: CustomerRecipe[];
}